import { GtmEvents } from '@/gtm/gtm-events';

export class HeaderGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВХедере';

  clickMenuItem({ path = [] }) {
    return this.gtmEvent({
      eventAction: 'Меню_КликПоМеню',
      eventLabel: path.join(' / '),
    });
  }

  clickWidgetOrders() {
    return this.gtmEvent({
      eventAction: 'Хедер_Заказы_Клик',
    });
  }

  clickWidgetOrder() {
    return this.gtmEvent({
      eventAction: 'Хедер_Заказы_Выбран',
    });
  }
}

export const headerGtmEvents = new HeaderGtmEvents();
